module.exports = __webpack_public_path__ + "img/stay-tuned.3f24674f.svg";